import React, { useEffect, useState } from 'react';

import HeaderSection from '../../common/Header/HeaderSection';
import QueueInfoPanel from '../../common/QueueInfo/QueueInfo';
import { StandardButton } from '../../common/Button';
import JoinQueueForm from '../../common/JoinForm/JoinForm';
import styles from './JoinQueue.module.scss';
import { Container, Col, Row } from 'react-bootstrap/esm/';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getBasicQueueInfoByDate,
  dbQueueWithCurDateRef,
} from '../../../api/queue';
import {
  ref,
  child,
  get,
  update,
  orderByChild,
  equalTo,
  remove,
  onValue,
} from 'firebase/database';
import { format } from 'date-fns';
import Toast from '../../common/Toast';
import EmailNotification from '../../../utils/EmailNotification/EmailNotification'

function JoinQueue({ queueId, onCancel }) {
  const [canJoin, setCanJoin] = useState(true);
  const [isRefresh, setIsRefresh] = useState(false);
  const [queueBasicInfo, setQueueBasicInfo] = useState(null);
  const [guestData, setGuestData] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (queueId) {
      getBasicQueueInfoByDate(queueId)
        .then((snapshot) => {
          setQueueBasicInfo(snapshot.basicInfo);

          const guestList = snapshot.guests;
          if (guestData && guestData.id) {
            navigate(`/join/token/${guestData.id}`, { state: guestData });
          }
        })
        .catch((err) => {
          console.error('\tError with ', err.message);
        });
    }
  }, [queueId, isRefresh]);

  const onSetGuestData = (guestData) => {
    setGuestData(guestData);
  };

  const handleAddGuest = async (guestToken) => {
    setCanJoin(true);
    try {
      //Getting queue status
      const snapshot = await getBasicQueueInfoByDate(queueId);
      if (snapshot) {
        setQueueBasicInfo(snapshot.basicInfo);
        if (snapshot.basicInfo.status !== 'Active') {
          setCanJoin(false);
          return;
        }

        const guestList = snapshot.guests;
        const activeGuests = guestList
          ? Object.values(guestList).filter(
              (value) =>
                value.status === 'waiting' ||
                value.status === 'waiting-notified'
            ).length
          : 0;

        if (activeGuests >= Number(snapshot.basicInfo.limit)) {
          setCanJoin(false);
          return;
        }
        guestToken.number =
          (guestList ? Object.values(guestList).length : 0) + 1;
        guestToken.position = activeGuests + 1;
      }

      const dbRef = dbQueueWithCurDateRef(queueId, '/guests');

      const curDate = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
      guestToken['updatedAt'] = curDate;
      const updateList = {};
      updateList[`/${guestToken.id}`] = guestToken;

      await update(dbRef, updateList);
      if (guestToken.id) {
        setGuestData(guestToken);
        EmailNotification({
          guestName: guestToken.name,
          guestEmail: guestToken.email,
          subjectLine: 'You are added to the queue',
          fromName: 'Queue Me Up team',
          message: `Hi, you can monitor your progress here: http://localhost:3000/join/token?guestId=${guestToken.id}&queueId=${guestToken.queueId}`,
        });
        navigate(
          `/join/token?guestId=${guestToken.id}&queueId=${guestToken.queueId}`
        );
      }
    } catch (err) {
      console.error('\tError: ', err.message);
    }
  };

  const onRefreshClick = () => {
    setCanJoin(true);
    setIsRefresh(!isRefresh);
  };

  const showJoinForm = () => {
    if (queueBasicInfo.status !== 'Active') {
      return (
        <>
          <p className={styles['message']}>
            Hi! The line is currently not accepting people currently.
          </p>
          <p className={styles['message']}>
            Wait until the line starts accepting people again, or contact the
            queue manager
          </p>
          <div className={styles.form}>
            <StandardButton onClick={onRefreshClick}>
              Check Again
            </StandardButton>
          </div>
        </>
      );
    }
    return (
      <div className={styles['join-form-container']}>
        {!canJoin && (
          <Toast subTitle="This queue temporarily does not allow to join. Please come back after some minutes." />
        )}
        <h4 className={styles['message']}>Enter your information</h4>
        <p className={styles['info']}>
          <i>Please make sure the contact number is correct and available.</i>
        </p>
        <JoinQueueForm
          queueId={queueId}
          queueInfo={queueBasicInfo}
          onJoin={onSetGuestData}
          onAddGuest={handleAddGuest}
          onCancel={onCancel}
        />
      </div>
    );
  };

  if (queueBasicInfo)
    return (
      <div className={styles['user-page']}>
        <HeaderSection
          title={queueBasicInfo.name}
          subTitle={queueBasicInfo.description}
        />
        <div className={'container'}>
          <Row className={styles['main-content']}>
            {/* or Show enter information form */}
            <Col md={4} xs={8} className={`mx-auto ${styles['queue-stats']}`}>
              <QueueInfoPanel queueInfo={queueBasicInfo} expendable={false} />
            </Col>
            <Col md={7} xs={12}>
              {showJoinForm()}
            </Col>
          </Row>
        </div>
      </div>
    );
  return null;
}
export default JoinQueue;
